import {ClmPerformanceOutput} from "./clm-performance-output";
import {ClmPerformanceInput} from "./clm-performance-input";
import {ClmElectricalOutput} from "./clm-electrical-output";
import {ClmBeltDriveOutput} from "./clm-belt-drive-output";

export class ClmPerformanceResponse {

  userSelection!: ClmPerformanceInput;
  coolingData!: ClmPerformanceOutput;
  heatingData!: ClmPerformanceOutput;
  electricalData!: ClmElectricalOutput;
  beltDriveSelection!: ClmBeltDriveOutput;

}
